import { ReduxStore } from 'store/types';

function getAllErrorMessage(state: ReduxStore): string {
  return state.user.getAll.config.errorMessage;
}

export default getAllErrorMessage;
